import { post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import WebEvaluation1InitRequest from "../form/request/WebEvaluation1InitRequest";
import WebEvaluation1SelectRequest from "../form/request/WebEvaluation1SelectRequest";

const API_PREFIX = "/webEvaluation1";

export const init = async request => {
  const response = await post(`${API_PREFIX}/`, new WebEvaluation1InitRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};

export const selected = async request => {
  const response = await post(`${API_PREFIX}/selected`, new WebEvaluation1SelectRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};

export const back = async request => {
  const response = await post(`${API_PREFIX}/back`, new WebEvaluation1SelectRequest(request), authHeader());
  console.log("response", response);
  return response.data;
};
